import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

export function subscribeToTokenBalance(uid, onBalance, onError) {
  return onSnapshot(doc(db, 'suite-users', uid), snapshot => {
    const balance = snapshot.data()?.tokenBalance;
    onBalance(Number.isSafeInteger(balance) ? balance : 0);
  }, onError);
}
